import { useLocation, useNavigate } from "react-router-dom";
import WithTableView from "../../components/withTableView/withTableView";
import Pagination from "../../components/pagination/pagination";
import { useEffect, useState } from "react";
import { deleteByIdApi, getAllApi } from "../../api";
import toast from "react-hot-toast";
import Modal from "../../components/modal/modal";

const Solutions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [inFocus, setInFocus] = useState("");
  const [modal, setModal] = useState(false);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    getAllApi("solution")
      .then((response) => {
        setBlogs(response.data.map((v) => ({ ...v, id: v._id })));
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setBlogs([]);
        toast.error("Not Found.");
      });
  };

  const handleDelete = () => {
    setModal(false);
    const promise = new Promise((resolve, reject) => {
      deleteByIdApi("solution", inFocus)
        .then((res) => {
          setInFocus("");
          resolve(true);
        })
        .catch((err) => {
          reject();
        });
    });

    toast
      .promise(
        promise,
        {
          loading: "Deleting...",
          success: "Deleted Successfully.",
          error: "Error when deleting the entry.",
        },
        { success: { duration: 2000 }, error: { duration: 2000 } }
      )
      .then(() => {
        getData();
      });
  };

  return (
    <>
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setModal(false);
          setInFocus("");
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <WithTableView
        heading="Solutions"
        head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
        body_keys={["title", "action:delete"]}
        body={blogs}
        show_btn_1={true}
        btn1Text="Solution"
        btn1Type="filled"
        onClickHandler={() => navigate("/solutions/add")}
        isIcon={true}
        iconType="add"
        onRowClick={(id) => {
          navigate("/solutions/" + id._id);
        }}
        onActionClick={(id, val) => {
          setInFocus(val);
          setModal(true);
        }}
        loading={loading}
        customElement={<></>}
      />
    </>
  );
};

export default Solutions;
